import { render, staticRenderFns } from "./MoleculeContentEditorBlockImage.vue?vue&type=template&id=2268cf66&"
import script from "./MoleculeContentEditorBlockImage.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports